import {
  isAnyCommunityCategory,
  isAnyJobsCategory,
  isAnyPetsCategory,
  isAnyRealEstateCategory,
  isAnyServicesCategory,
  isAnyVacationRentalsCategory,
} from '@kijiji/category'

import { RemoteParamKeys } from '@/lib/firebase/config'
import { type BasePageProps } from '@/pages/_app'

export const WHITELIST_API_TOGGLE_KEY = 'KJCA-6569'

const categoryChecks = [
  isAnyVacationRentalsCategory,
  isAnyServicesCategory,
  isAnyCommunityCategory,
  isAnyJobsCategory,
  isAnyPetsCategory,
  isAnyRealEstateCategory,
  // Add more category checks here as needed
]

/**
 * Determines whether to apply the whitelist API feature based on category and Firebase remote config.
 * This utility is used to selectively enable the whitelist API for specific categories.
 *
 * @param categoryId - The numerical ID of the category being checked
 * @param basePageProps - The base page props containing Firebase configuration and toggles
 * @returns An object containing the KJCA-6569 feature flag if the category qualifies,
 *          or an empty object if the category doesn't match the criteria.
 *          Returns { 'KJCA-6569': 1 } when enabled, { 'KJCA-6569': -1 } when disabled,
 *          or {} when the category doesn't qualify.
 */
export const getWhitelistApiToggle = (categoryId: number, basePageProps: BasePageProps) => {
  const whitelistApiEnabled =
    basePageProps?.firebaseConfig?.toggles?.[RemoteParamKeys?.WHITELIST_API]?.enabled ?? false
  const shouldApplyToggle = categoryChecks.some((check) => check(categoryId))

  if (!shouldApplyToggle) {
    return {}
  }

  return {
    [WHITELIST_API_TOGGLE_KEY]: whitelistApiEnabled ? 1 : -1,
  }
}
